"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BindedCube {
    constructor(cube, template) {
        this.cube = cube;
        this.template = template;
    }
    update(parameters) {
        const query = this.buildQuery(parameters);
        const result = this.cube.query(query);
        return result;
    }
    buildQuery(parameters) {
        const template = this.template;
        const mappedParameters = template.parametersMapping.reduce((acc, { cubeParameterId, reportParameterId }) => {
            const parameterValue = parameters[reportParameterId];
            acc[cubeParameterId] = parameterValue;
            return acc;
        }, {});
        // remap axes
        const rowAxis = this.buildAxis(template.rows, mappedParameters);
        const columnsAxis = this.buildAxis(template.columns, mappedParameters);
        const filterAxis = this.buildAxis(template.filter, mappedParameters);
        const query = {
            sourceResolveOptions: template.sourceResolveOptions,
            rows: rowAxis,
            columns: columnsAxis,
            filter: filterAxis,
            sorting: template.sorting,
        };
        return query;
    }
    buildAxis(template, parameters) {
        const measuresAxisPartId = "Measures";
        const axisParts = template.parts.map((axisPartTemplate) => {
            if (axisPartTemplate.path == measuresAxisPartId) {
                const measuresAxisPartTemplate = axisPartTemplate;
                // process measures axis part
                return {
                    path: measuresAxisPartId,
                    measures: measuresAxisPartTemplate.measures
                };
            }
            else {
                const { id, selectionMode, boundParameterId, selection } = axisPartTemplate;
                // process hierarchies axis part
                const selectionValue = boundParameterId !== undefined ? parameters[boundParameterId] : selection;
                return {
                    path: id,
                    selectionMode: selectionMode,
                    selection: selectionValue,
                };
            }
        });
        return {
            showEmpty: template.showEmpty,
            parts: axisParts,
        };
    }
}
exports.BindedCube = BindedCube;
//# sourceMappingURL=BindedCube.js.map